<script lang="ts" setup>
    import { OffsetGroup } from '~/data/OffsetGroup'

    const { block, grid = true } = defineProps<{
        block: FeaturedProjectBlock
        grid?: boolean
    }>()

    const offset = OffsetGroup.fromData(block)

    let project: Project | undefined

    if (block.project) {
        const { data: projectData } = await useStatamicEntries().getEntryById<Project>({
            collection: 'projects',
            value: block.project.id,
        })

        project = projectData.value
    }
</script>

<template>
    <div v-if="grid && project" class="layout-grid">
        <ProjectItem :project="project" :class="offset.classes" />
    </div>

    <ProjectItem v-else-if="project" :project="project" :class="offset.classes" />
</template>
